import { useState } from 'react';
import '../scss/layout.scss';
import { MenuOutlined } from '@ant-design/icons';
import QADdark from '../assets/logo-qad-dark.png';

export const Header = () =>{
    const [isOpen, setIsOpen] = useState(false);

    const onJump = (name, block) => {
        document.querySelector(name).scrollIntoView({
            behavior: 'smooth',
            block: block,
        });
        setIsOpen(false);
    }
    return(
        <div className='header'>
            <p  onClick={()=>onJump('#home','start')} style={{cursor:"pointer"}}>
                <img src={QADdark} alt='QADworks Logo'/>
            </p>
            <div className='menu'>
                <button className='menu-item' onClick={()=>onJump('#data-into-decisions','center')}>
                        Data into Decisions
                </button>
                <button className='menu-item' onClick={()=>onJump('#digital-transformation','start')}>
                        Our Work
                </button>
                <button className='menu-item' onClick={()=>onJump('#partners','center')}>
                    Partners
                </button>
            <button className='burger-menu' onClick={()=>setIsOpen(!isOpen)}>
                <MenuOutlined/>
            </button>
            <div className={isOpen?'side-menu':'side-menu-closed'}>
                <button className='sidemenu-item' onClick={()=>onJump('#data-into-decisions','start')}>
                        Data into Decisions
                </button>
                <button className='sidemenu-item' onClick={()=>onJump('#digital-transformation','start')}>
                        Our Work
                </button>
                    <button className='sidemenu-item' onClick={()=>onJump('#partners','center')}>
                    Partners
                </button>
            </div>
            </div>
        </div>
    )
}